import * as CONST from 'Reducers/UIBlock/const'

/**
 * Increment block counter
 *
 * @returns {{type}}
 */
export function incUIBlockCounter() {
  return {
    //type: CONST.INCREMENT_BLOCK_COUNTER,
    type: 'noop',
  }
}

/**
 * Decrement block counter
 *
 * @returns {{type}}
 */
export function decBlockCounter() {
  return {
    type: CONST.DECREMENT_BLOCK_COUNTER,
  }
}

/**
 * Enable UIBlock
 *
 * @returns {{type}}
 */
export function enableUIBlock() {
  return {
    type: CONST.ENABLE_UI_BLOCK,
  }
}

/**
 * Disable UIBlock
 *
 * @returns {{type}}
 */
export function disableUIBlock() {
  return {
    type: CONST.DISABLE_UI_BLOCK,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/UIBlock/actions.js